export const hotGossipItems = [
  {
    id: 1,
    slug: 'wanghong-a-fangche-shijian',
    title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
    category: '网红塌房',
    heat: '98.7万',
    heatNum: 987000,
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20stage%20with%20dramatic%20red%20and%20crimson%20spotlight%2C%20silhouette%20of%20a%20person%20on%20stage%20facing%20away%2C%20mysterious%20and%20scandalous%20vibe%2C%20editorial%20photography%20with%20high%20contrast%20lighting%2C%20warm%20dark%20tones%2C%20cinematic%20mood%2C%20grainy%20film%20texture%2C%20professional%20composition%20with%20negative%20space%2C%20simple%20background%20with%20subtle%20red%20gradient&width=600&height=600&seq=gossip-card-01&orientation=squarish',
    time: '2小时前',
    summary: '曾经标榜公益人设的千万粉网红，被内部人士爆料所有慈善项目均为作秀，背后更有神秘资本运作。',
  },
  {
    id: 2,
    slug: 'daihuo-yijie-bengpan',
    title: '直播带货一姐偷税案后续：补缴金额高达数亿，团队核心成员被带走',
    category: '黑料吃瓜',
    heat: '86.3万',
    heatNum: 863000,
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20items%20scattered%20on%20floor%2C%20dramatic%20crimson%20lighting%20from%20above%2C%20fallen%20crown%20symbolism%2C%20editorial%20fashion%20photography%20style%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%2C%20grainy%20atmosphere%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=600&seq=gossip-card-02&orientation=squarish',
    time: '5小时前',
    summary: '继上次被罚后，更多偷税细节浮出水面，团队多名核心成员已被警方带走调查。',
  },
  {
    id: 3,
    slug: 'ouxiang-lianai-baoguang',
    title: '顶流男偶像隐婚生子被拍，工作室紧急公关删帖反被扒出更多实锤',
    category: '网红塌房',
    heat: '75.2万',
    heatNum: 752000,
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20paparazzi%20style%20scene%2C%20shadowy%20figure%20walking%20away%20with%20mysterious%20mood%2C%20dramatic%20red%20and%20amber%20backlight%2C%20cinematic%20noir%20photography%2C%20warm%20dark%20tones%20with%20crimson%20highlights%2C%20grainy%20texture%2C%20simple%20dark%20gradient%20background%2C%20editorial%20composition&width=600&height=600&seq=gossip-card-03&orientation=squarish',
    time: '8小时前',
    summary: '一向以单身人设圈粉的顶流男星，被狗仔拍到深夜带娃出街，粉丝集体破防。',
  },
  {
    id: 4,
    slug: 'duan-shipin-dajiang',
    title: '短视频平台头部主播因言论不当被全网封杀，千万账号一夜归零',
    category: '黑料吃瓜',
    heat: '69.8万',
    heatNum: 698000,
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20shattered%20phone%20screen%20displaying%20error%20message%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20symbolic%20imagery%20of%20digital%20downfall%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=600&seq=gossip-card-04&orientation=squarish',
    time: '12小时前',
    summary: '该主播在直播中发表极端言论引发众怒，平台连夜出手全面封禁其所有账号。',
  },
  {
    id: 5,
    slug: 'meishi-bozhu-fanshui',
    title: '知名美食博主被曝收钱做虚假测评，多家品牌连夜解约索赔',
    category: '吃瓜爆料',
    heat: '63.5万',
    heatNum: 635000,
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20studio%20kitchen%20scene%20in%20disarray%2C%20dramatic%20crimson%20spotlight%20from%20side%2C%20mysterious%20mood%2C%20editorial%20food%20photography%20gone%20wrong%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=600&seq=gossip-card-05&orientation=squarish',
    time: '1天前',
    summary: '收钱黑竞品的聊天记录被曝光，涉及金额惊人，多家品牌宣布终止合作。',
  },
];

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红塌房', href: '/category/wanghong-tafang' },
  { label: '黑料吃瓜', href: '/category/heiliao-chigua' },
  { label: '吃瓜爆料', href: '/category/chigua-baoliao' },
  { label: '每日大赛', href: '/category/meiri-dasai' },
  { label: '关于我们', href: '/about' },
];

export const footerColumns = [
  {
    title: '热门入口',
    links: [
      { label: '51吃瓜网站入口', href: '/category/51-chigua' },
      { label: '51吃瓜在线观看', href: '/category/51-chigua-online' },
      { label: '吃瓜网址大全', href: '/category/chigua-urls' },
      { label: '51吃瓜官网', href: '/category/51-chigua-official' },
    ],
  },
  {
    title: '吃瓜分类',
    links: [
      { label: '网红塌房', href: '/category/wanghong-tafang' },
      { label: '黑料吃瓜', href: '/category/heiliao-chigua' },
      { label: '吃瓜爆料', href: '/category/chigua-baoliao' },
      { label: '每日大赛', href: '/category/meiri-dasai' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '品牌信誉', href: '/about#reputation' },
      { label: '联系方式', href: '/about#contact' },
      { label: '用户口碑', href: '/about#testimonials' },
    ],
  },
  {
    title: '网站导航',
    links: [
      { label: '最新爆料', href: '/' },
      { label: '热门排行', href: '/category/hot' },
      { label: '51吃瓜视频', href: '/category/51-chigua-video' },
      { label: '在线吃瓜', href: '/category/online-chigua' },
    ],
  },
];

export const heroText = {
  line1: '吃瓜网站线路一',
  line2: '每日大赛 · 实时追踪',
  subtitle: '聚合51吃瓜网站入口与51吃瓜在线观看等热门通道，每日更新网红塌房黑料，一站式直达最新大瓜现场',
  cta: '立即吃瓜',
};